import {
  Directive,
  ElementRef,
  Renderer2,
  effect,
  inject,
} from '@angular/core';
import { NgpError, injectFormFieldState } from 'ng-primitives/form-field';

@Directive({
  selector: '[sui-error]',
  standalone: true,
  hostDirectives: [
    { directive: NgpError, inputs: ['ngpErrorValidator: sui-error'] },
  ],
})
export class SuiErrorDirective {
  private readonly el = inject(ElementRef<HTMLElement>);
  private readonly renderer = inject(Renderer2);
  private readonly formField = injectFormFieldState({ optional: true });
  private readonly ngpError = inject(NgpError);

  constructor() {
    this.renderer.setStyle(this.el.nativeElement, 'display', 'none');

    effect(() => {
      const touched = !!this.formField()?.touched();
      const validator = this.ngpError.validator();
      const errors: string[] = this.formField()?.errors() ?? [];
      const hasError = validator
        ? errors.includes(validator)
        : errors.length > 0;
      this.renderer.setStyle(
        this.el.nativeElement,
        'display',
        touched && hasError ? '' : 'none',
      );
    });
  }
}
